import { ChainID } from '@ankr.com/chains-list';

import { PRODUCTS_PAGE_PATHNAME } from 'modules/chains/constants';

export interface IsFromProductsPageParams {
  chainID: ChainID;
}

export const isFromProductsPage = ({ chainID }: IsFromProductsPageParams) => {
  const referrer = document.referrer;

  if (!referrer) {
    return false;
  }

  const referrerUrl = new URL(referrer);
  const { pathname } = referrerUrl;

  return pathname === PRODUCTS_PAGE_PATHNAME.replace(':chainID', chainID);
};
